/* unplugin-vue-components disabled */import script from "./BindingSuccess.vue?vue&type=script&lang=ts&setup=true"
export * from "./BindingSuccess.vue?vue&type=script&lang=ts&setup=true"

import "./BindingSuccess.vue?vue&type=style&index=0&id=943f1c02&lang=less&scoped=true"

import exportComponent from "/data/liulv-h5/quantum-technology/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-943f1c02"]])

export default __exports__